import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthlayoutComponent } from './layouts/authlayout/authlayout.component';
import { LoginGuard } from './core/guards/login.guard';
import { Basic404Component } from './extrapages/basic404/basic404.component';
import { BusinesslayoutComponent } from './layouts/businesslayout/businesslayout.component';
import { TermsAndConditionComponent } from './extrapages/terms-and-condition/terms-and-condition.component';
import { resolveGuard } from './core/guards/resolve.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'pages',
    loadChildren: () => import('./extrapages/extrapages.module').then((m) => m.ExtrapagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    component: LayoutComponent,
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'auth',
    component: AuthlayoutComponent,
    loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
    canActivate: [LoginGuard],
  },
  // {
  //   path: 'business-portal',
  //   component: BusinesslayoutComponent,
  //   title: 'Nirlat - Business Portal',
  //   loadChildren: () => import('./business-portal/business-portal.module').then((m) => m.BusinessPortalModule),
  // },
  // {
  //   path: 'business-card',
  //   loadChildren: () => import('./extrapages/business-card/business-card.module').then((m) => m.BusinessCardModule),
  // },
  {
    path: 'content/:content-type',
    component: TermsAndConditionComponent,
  },
  {
    path: 'b/:nanoid',
    canActivate: [resolveGuard],
  },
  { path: '**', component: Basic404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
